<span class="mt-3" style="padding:10px;" *ngFor="let badge of badgeList; let i=index;">
    <a [href]="badge.link" class="badge-link" target="_blank">
        <!-- Google -->
        <img [alt]="badge.image" [class.splitScreen]="splitScreen" [src]="badge.image" height="60" width="180"
            style="margin-top: 15px;" />
    </a>
</span>